<template>
<div @click="asd()" style="width:100px; height: 100px; background-color: #0d47a1">
    qwe
</div>
</template>

<script>
  export default {
    name: 'Test',
    methods: {
      asd() {
        console.log('qwe');
      }
    }
  }
</script>

<style scoped>

</style>
